import React, { useState, useEffect } from "react";
import {
  listarMotivoOferta,
  adicionarMotivoOferta,
  alterarMotivoOferta,
  toggleMotivoOferta,
} from "../../../services/http/motivoOfertaService";
import { useSnackBar } from "../../../hooks/snackBar";
import "../../Configuracoes/MotivoOfertaTab/styles.scss";

const MotivoOfertaTab = () => {
  const { addSnackBar } = useSnackBar();

  const [motivoList, setMotivoList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [novoMotivo, setNovoMotivo] = useState("");
  const [editandoId, setEditandoId] = useState(null);
  const [editandoDescricao, setEditandoDescricao] = useState("");
  const [motivoEditando, setMotivoEditando] = useState(null);

  // Carregar lista de motivos ao montar o componente
  useEffect(() => {
    carregarMotivoList();
  }, []);

  const carregarMotivoList = async () => {
    try {
      setLoading(true);
      const response = await listarMotivoOferta();
      console.log(response);
      if (response.fail == null) {
        setMotivoList(response.data || []);
      } else {
        addSnackBar({
          message: response.errors[0].menssagem || "Erro ao carregar motivos",
          info: "error",
          open: true,
        });
      }
    } catch (error) {
      addSnackBar({
        message: "Erro ao carregar motivos",
        info: "error",
        open: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleToggleMotivo = async (id) => {
    try {
      const motivo = motivoList.find((m) => m.id === id);
      const novoStatus = !motivo.ativo;

      const response = await toggleMotivoOferta(id, novoStatus);
      console.log(response.fail == null);
      if (response.fail == null) {
        setMotivoList((prev) =>
          prev.map((motivo) =>
            motivo.id === id ? { ...motivo, ativo: novoStatus } : motivo
          )
        );
        addSnackBar({
          message: novoStatus ? "Motivo ativado com sucesso" : "Motivo inativado com sucesso",
          info: "success",
          open: true,
        });

      } else {
        addSnackBar({
          message: response.errors[0].menssagem || "Erro ao alterar motivo",
          info: "error",
          open: true,
        });
      }
      
    } catch (error) {
      console.error("Erro ao alterar motivo:", error);
      addSnackBar({
        message: "Erro ao alterar motivo",
        info: "error",
        open: true,
      });
    }
  };

  const handleEditar = (motivo) => {
    setEditandoId(motivo.id);
    setEditandoDescricao(motivo.descricao);
    setMotivoEditando(motivo);
  };

  const handleSalvarEdicao = async () => {
    if (editandoDescricao.trim()) {
      try {
        const response = await alterarMotivoOferta({
          id: editandoId,
          descricao: editandoDescricao.trim(),
          ativo: motivoEditando.ativo,
          dataCriacao: motivoEditando.dataCriacao,
        });

        console.log(response);
        if (response.fail == null) {
          setMotivoList((prev) =>
            prev.map((motivo) =>
              motivo.id === editandoId
                ? { ...motivo, descricao: editandoDescricao.trim(), dataAtualizacao: new Date().toISOString() }
                : motivo
            )
          );
          setEditandoId(null);
          setEditandoDescricao("");
          setMotivoEditando(null);
          addSnackBar({
            message: "Motivo atualizado com sucesso",
            info: "success",
            open: true,
          });
        } else {
          addSnackBar({
            message: response.errors[0].menssagem || "Erro ao editar motivo",
            info: "error",
            open: true,
          });
        }
      } catch (error) {
        console.error("Erro ao editar motivo:", error);
        addSnackBar({
          message: "Erro ao editar motivo",
          info: "error",
          open: true,
        });
      }
    }
  };

  const handleCancelarEdicao = () => {
    setEditandoId(null);
    setEditandoDescricao("");
    setMotivoEditando(null);
  };

  const handleAdicionarMotivo = async () => {
    if (novoMotivo.trim()) {
      try {
        const response = await adicionarMotivoOferta({
          descricao: novoMotivo.trim(),
        });

        if (response.fail == null) {
          // Recarregar a lista para obter o novo motivo com ID do servidor
          await carregarMotivoList();
          setNovoMotivo("");
          addSnackBar({
            message: "Motivo adicionado com sucesso",
            info: "success",
            open: true,
          });
        } else {
          addSnackBar({
            message: response.errors[0].menssagem || "Erro ao adicionar motivo",
            info: "error",
            open: true,
          });
        }
      } catch (error) {
        console.error("Erro ao adicionar motivo:", error);
        addSnackBar({
          message: "Erro ao adicionar motivo",
          info: "error",
          open: true,
        });
      }
    }
  };

  if (loading) {
    return (
      <div className="motivo-oferta-container">
        <div className="row d-flex justify-content-center">
          <div className="col-12 text-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Carregando...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="motivo-oferta-container">
      <div className="row mb-3">
        <div className="col-12">
          <h2 className="titulo">Motivo da Oferta</h2>
        </div>
      </div>

      {/* Seção de adicionar novo motivo */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="add-motivo-section">
            <div className="row">
              <div className="col-md-8">
                <input
                  type="text"
                  value={novoMotivo}
                  onChange={(e) => setNovoMotivo(e.target.value)}
                  placeholder="Digite o novo motivo"
                  className="form-control"
                  onKeyPress={(e) =>
                    e.key === "Enter" && handleAdicionarMotivo()
                  }
                />
              </div>
              <div className="col-md-4">
                <button
                  className="button-anexar buton-green w-100"
                  onClick={handleAdicionarMotivo}
                  disabled={!novoMotivo.trim()}
                >
                  ADICIONAR MOTIVO
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Lista de motivos */}
      <div className="row">
        <div className="col-12">
          <div className="motivo-list">
            {motivoList.map((motivo) => (
              <div
                key={motivo.id}
                className={`motivo-item ${!motivo.ativo ? "inativo" : ""}`}
              >
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="motivo-field">
                      {editandoId === motivo.id ? (
                        <input
                          type="text"
                          value={editandoDescricao}
                          onChange={(e) => setEditandoDescricao(e.target.value)}
                          className="form-control"
                          autoFocus
                          onKeyPress={(e) =>
                            e.key === "Enter" && handleSalvarEdicao()
                          }
                        />
                      ) : (
                        <span className="motivo-nome">{motivo.descricao}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="motivo-actions">
                      {editandoId === motivo.id ? (
                        <div className="row">
                          <div className="col-6">
                            <button
                              className="buton-green w-100"
                              onClick={handleSalvarEdicao}
                            >
                              Salvar
                            </button>
                          </div>
                          <div className="col-6">
                            <button
                              className="buton-white-black-border w-100"
                              onClick={handleCancelarEdicao}
                            >
                              Cancelar
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="row">
                          <div className="col-6">
                            <button
                              className="buton-white-black-border w-100"
                              onClick={() => handleEditar(motivo)}
                            >
                              Editar
                            </button>
                          </div>
                          <div className="col-6">
                            <button
                              className={
                                motivo.ativo
                                  ? "buton-red w-100"
                                  : "buton-green w-100"
                              }
                              onClick={() => handleToggleMotivo(motivo.id)}
                            >
                              {motivo.ativo ? "Inativar" : "Ativar"}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MotivoOfertaTab;

